import React from 'react';
import { useSelector } from 'react-redux';
import getBundleGroups from 'store/product/selector/getBundleGroups';
import SelectedBundleProducts from '../SelectedBundleProducts/SelectedBundleProducts';

const BundleProducts = () => {
  const bundleGroups = useSelector(getBundleGroups);

  if (!bundleGroups.length) {
    return null;
  }

  return (
    <div>
      {bundleGroups.map((bundleGroup) => (
        <SelectedBundleProducts key={`bg${bundleGroup.bundleGroupId}`} bundleGroup={bundleGroup} />
      ))}
    </div>
  );
};

export default BundleProducts;
